import React from 'react'
import moment from 'moment'
import classnames from 'classnames'
import { startCase } from 'lodash'
import { useSelector } from 'react-redux'

export default function AgendaItem(props) {
  const { title, description, due_date, status, url, kind, starts_at, ends_at, all_day, starts_at_time, ends_at_time } = props
  return (
    <a href={url}
      target="_blank"
      className="pt-2 pb-2 pl-3 pr-3 border d-block clickable hoverable mb-3 cursor-pointer bg-white"
      style={{textDecoration: 'none', color: 'black'}}>
      <div className="d-flex justify-content-between">
    <small className="font-weight-bold text-secondary text-uppercase">{kind}</small>
        <Status status={status}/>
      </div>
      <b className="d-block">{title || 'No Title'}</b>
      <p className="mb-0"><i>{description || 'No Description'}</i></p>
      <small className="text-secondary text-uppercase" style={{fontWeight: '600'}}>
        {
          due_date ?
          <span>due by {moment(due_date).format("MM/DD/YYYY @ h:mm a")}</span>
          : all_day ?
            <span>{ moment(starts_at).format('LL') } - { moment(ends_at).format('LL') }</span>
            :
            <span>{ ( starts_at_time || moment(starts_at).format('h:mm a') ) } - { ( ends_at_time || moment(ends_at).format('h:mm a') ) }</span>
        }

      </small>
    </a>
  )
}

function Status(props){
  const { status } = props

  return(
    <div className={classnames("badge p-1 text-uppercase",{
      " text-warning border-warning": status == 'pending_completing',
      "text-danger border-danger": status == 'overdue' || status == 'Skipped',
      "badge-success": ( status == 'completed' || status == 'checked_in' || status == 'completed' ),
      "badge-warning": ( status == 'current' || status == 'no_checkin' ),
      "badge-secondary": status == 'upcoming' || status == 'Scheduled',
      "badge-danger": status == 'completed_late',
      })}>
      { status == 'pending_completing' ? 'Pending Review' : startCase(status) }
    </div>
  )
}

export function ResourceComponent(props){
  const {sender_url, sender_name, isStaffApp} = useSelector(state=>state.config)
  switch(props.resource_type){
    case "Event":
    case "Checkin":
      return <AgendaItem
        kind={"Event"}
        title={props.title}
        description={props.description}
        starts_at={props.starts_at}
        starts_at_time={props.starts_at_time}
        ends_at_time={props.ends_at_time}
        ends_at={props.ends_at}
        status={props.status}
        url={`/organizations/${props.organization.name}/events/${props.id}${isStaffApp ? '/edit' : ''}?starts_at=${props.starts_at}&ends_at=${props.ends_at}&sender=${sender_url}&sender_name=${sender_name}`}
      />
    case "Goal":
      return <AgendaItem
        kind={props.resource_type}
        title={props.title}
        description={props.description}
        due_date={props.due}
        status={props.status}
        url={`/organizations/${props.organization.name}/goals/${props.id}/edit?sender=${sender_url}&sender_name=${sender_name}`}
      />
    case "FormRequest":
      return <AgendaItem
        kind="Form Request"
        title={!!props.form ? props.form.title : ''}
        description={props.notes}
        due_date={props.due_date}
        status={props.status}
        url={`/organizations/${props.organization.name}/form_requests/${props.id}/edit?sender=${sender_url}&sender_name=${sender_name}`}
      />
    case "SurveyRequest":
      return <AgendaItem
        kind="Survey Request"
        title={props.resident_survey.name}
        description={props.notes}
        due_date={props.due_date}
        status={props.status}
        url={`/organizations/${props.organization.name}/survey_requests/${props.id}/edit?sender=${sender_url}&sender_name=${sender_name}`}
      />
    case "DrugTestRequest":
      return <AgendaItem
        kind="Drug Test Request"
        title={props.kind}
        description={props.notes}
        due_date={props.due_date}
        status={props.status}
        url={`/organizations/${props.organization.name}/drug_test_requests/${props.id}?sender=${sender_url}&sender_name=${sender_name}`}
      />
    default:
      return <div className="p-3 border mb-3 w-100">{JSON.stringify(props)}</div>
  }
}
